<template>
  <div class="outerbox onoutbox">
    <div class="innercoreversion contene">
      <div class="titleimg"><img src="../image/titlename.png" width="712px" alt="" /></div>
      <div class="haveimgbox">
        <div class="textbanebox">
          <div class="textmuqina">
            目前亿大师已经<span style="color: #57cc9a">成功合作十多个连锁品牌</span>
            ，行业涉及餐饮、茶饮、服装零售、百货零售、酒店、4S店、商场等
          </div>
          <div class="boutton" @click="scrollToAnchor">快速体验</div>
        </div>
        <div class="imgtt" ref="imganimate">
          <!-- animate__slower -->
          <img
            v-if="shownimate"
            src="../image/titlemanehave.png"
            :class="shownimate ? 'animate__animated animate__backInUp' : ''"
            width="684px"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'moreHave',
  data() {
    return {
      shownimate: false,
    }
  },
  mounted() {
    const target = this.$refs.imganimate
    // 创建 IntersectionObserver
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.shownimate = true
          console.log('盒子进入可视区间')
        } else {
          this.shownimate = false
          // this.observer.disconnect()
          console.log('盒子离开可视区间')
        }
      })
    })

    // 开始监听
    this.observer.observe(target)
  },
  methods: {
    scrollToAnchor() {
      const targetElement = document.getElementById('about')
      targetElement.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
        block: 'start', // 滚动到目标元素顶部
      })
    },
  },
  beforeDestroy() {
    this.shownimate = false
    // 停止观察以防止内存泄漏
    if (this.observer) {
      this.observer.disconnect()
    }
  },
}
</script>

<style lang="less" scoped>
.onoutbox {
  background: #293853;
  height: 535px;
  .contene {
    height: 100%;
    padding: 42px 0 49px 48px;
    // background: #db1212;
    display: flex;
    flex-direction: column;
    .titleimg {
      text-align: center;
      margin-bottom: 48px;
    }
    h1 {
      color: #fff;
    }
    .haveimgbox {
      flex: 1;
      color: #fff;
      display: flex;
      .textbanebox {
        padding: 38px 35px 68px 0;
        .textmuqina {
          font-weight: 300;
          font-size: 16px;
          color: #ffffff;
          line-height: 28px;
        }
        .boutton {
          width: 212px;
          height: 56px;
          margin-top: 69px;
          text-align: center;
          line-height: 56px;
          background: #57cc9a;
          border-radius: 37px 37px 37px 37px;
        }
      }
      .imgtt {
        margin-left: 61px;
      }
    }
  }
}
</style>